import React, {useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {FmlxComboBox} from 'fmlx-common-ui';
import {departmentBusiness} from '../../stores/business/departmentBusiness';
import {setIsDepartmentReady, setSelectedDepartment} from '../../stores/actions/departmentAction';
import {selectDepartments, selectSelectedDepartment} from '../../stores/selectors/departmentSelector';

/**
 * @deprecated
 * Avoid using DepartmentDropdown component.
 *
 * This component handles internal state (e.g. fetch, dispatch, auto-select),
 * which should be managed in the page level for better control and reusability.
 *
 * Use <FmlxComboBox /> directly in the page and handle data, selection, and events externally.
 */
function DepartmentDropdown({
  callbackChangeDepartment,
  departmentValue,
  isGetAllDept,
  disabled,
  OnHandleClearInputValue,
}) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.appState.user);
  const departmentList = useSelector(selectDepartments) || [];
  const selectedDepartment = useSelector(selectSelectedDepartment);
  const initializedRef = useRef(false);
  useEffect(() => {
    dispatch(departmentBusiness.fetchDepartments(isGetAllDept));
  }, [dispatch, isGetAllDept]);

  useEffect(() => {
    if (!departmentValue && departmentList.length > 0 && !initializedRef.current) {
      dispatch(setIsDepartmentReady(true));
      const initDept = departmentList.find((d) => d.id === user.departmentID);
      if (initDept) {
        dispatch(setSelectedDepartment(initDept));
        callbackChangeDepartment(initDept?.data);
        initializedRef.current = true;
      }
    } else if (departmentValue && departmentList.length > 0) {
      const selected = departmentList.find((d) => d.id === departmentValue.id);
      if (selected && (!selectedDepartment || selectedDepartment.id !== selected.id)) {
        dispatch(setSelectedDepartment(selected));
      }
    }
  }, [departmentList, departmentValue, user.departmentID, dispatch, selectedDepartment, callbackChangeDepartment]);

  const handleOnChange = useCallback(
    (value) => {
      dispatch(setSelectedDepartment(value));
      callbackChangeDepartment(value?.data || undefined);
    },
    [callbackChangeDepartment, dispatch]
  );

  return (
    <div>
      <FmlxComboBox
        id={'departmentDropdown'}
        loading={departmentList.length === 0}
        placeholder="Select a Department"
        items={departmentList}
        selectedItem={selectedDepartment}
        onChange={handleOnChange}
        disabled={disabled}
        showClearInput={true}
        showClearChip={true}
        onClearInputValue={OnHandleClearInputValue}
      />
    </div>
  );
}

DepartmentDropdown.propTypes = {
  callbackChangeDepartment: PropTypes.func,
  departmentValue: PropTypes.any,
  isGetAllDept: PropTypes.bool,
  disabled: PropTypes.bool,
};

DepartmentDropdown.defaultProps = {
  callbackChangeDepartment: () => {},
  departmentValue: null,
  isGetAllDept: false,
  disabled: false,
};

export default DepartmentDropdown;
